import api from "@/lib/api.ts";
import { AxiosResponse } from "axios";

export async function getStats() {
  return api
    .get("users/stats")
    .then(
      (
        response: AxiosResponse<{
          credits: number;
          characters: number;
          photos: number;
        }>,
      ) => response.data,
    );
}
